"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CTRL_CHARCODE = 'Control';
var ALT_CHARCODE = 'Alt';
var META_CHARCODE = 'Meta';
/**
 * Returns true when the event was fired from a modifier key, otherwise false
 * @param event The keyboard event object
 */
function isModifierKey(event) {
    var isCtrlKey = event.ctrlKey || event.key === CTRL_CHARCODE;
    var isAltKey = event.altKey || event.key === ALT_CHARCODE;
    var isMetaKey = event.metaKey || event.key === META_CHARCODE;
    return isCtrlKey || isAltKey || isMetaKey;
}
exports.default = isModifierKey;
//# sourceMappingURL=isModifierKey.js.map